export default __webpack_public_path__ + "static/media/Animals15.ed139a00.jpg";